import { Compass } from 'lucide-react';
import { Link } from 'react-router';
import { Button, EmptyState } from '@brimostech/ui';

export function NotFoundPage() {
  return (
    <div className="flex min-h-svh items-center justify-center p-6">
      <EmptyState
        icon={<Compass />}
        title="Página não encontrada"
        description="O endereço que você abriu não existe ou foi movido."
        action={
          <Button asChild>
            <Link to="/">Voltar ao início</Link>
          </Button>
        }
        className="w-full max-w-md"
      />
    </div>
  );
}
